import script from "./ContactCaptcha.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactCaptcha.vue?vue&type=script&setup=true&lang=js"

import "./ContactCaptcha.vue?vue&type=style&index=0&id=6345a64d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6345a64d"]])

export default __exports__